import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Observable, map } from 'rxjs';

import { ExternalLink } from '../../interfaces/external-link.interface';

interface ExternalLinkContent {
  url: string;
  teaserTitle: string;
}

@Component({
  selector: 'cms-external-link',
  template: '<fin-external-link [link$]="link$" />',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsExternalLinkComponent implements OnInit {
  @Input()
  content$: Observable<ExternalLinkContent>;

  link$: Observable<ExternalLink>;

  ngOnInit(): void {
    this.link$ = this.content$.pipe(
      map((data) => ({
        url: data.url,
        text: data.teaserTitle,
        target: '_blank',
      }))
    );
  }
}
